import Callback from '@/services/Callback'
import To from 'await-to-js'
import qs from 'qs'
import RecordOperation from '@/services/Record'
import { wizStandardInstance } from '@/services/instance'

export default class StdClassAttributeService {
  static async editattribute(payload) {
    RecordOperation({ type: 'query' })
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/StdClassAttribute/update_or_insert', payload)
    )
    return Callback(err, res)
  }
  static async listdetail(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`​/api/std/StdClassAttribute?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  static async detail(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/StdClassAttribute/?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  static async list(payload) {
    RecordOperation({ type: 'query' })
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/StdClassAttribute?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  static async create(payload) {
    const [err, res] = await To(wizStandardInstance.post('/api/std/StdClassAttribute', payload))
    return Callback(err, res)
  }
  static async update(payload) {
    const [err, res] = await To(wizStandardInstance.patch('/api/std/StdClassAttribute', payload))
    return Callback(err, res)
  }
  static async remove(payload) {
    RecordOperation({ type: 'delete' })
    const [err, res] = await To(wizStandardInstance.delete('/api/std/StdClassAttribute', payload))
    return Callback(err, res)
  }
  static async upload(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/StdClassAttribute/import', payload)
    )
    return Callback(err, res)
  }
  static async exportFile(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/StdClassAttribute/export', payload)
    )
    return Callback(err, res)
  }
  static async downloadTemplate(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/StdClassAttribute/download', payload)
    )
    return Callback(err, res)
  }
  static async getValueType(payload) {
    RecordOperation({ type: 'query' })
    const [err, res] = await To(
      wizStandardInstance.get('/api/std/StdClassAttribute/get_value_type', payload)
    )
    return Callback(err, res)
  }
  static async validRuleExpression(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/std/StdClassAttribute/valid_rule_expression?${qs.stringify(payload)}`
      )
    )
    return Callback(err, res)
  }
  static async getValidDefaultValueResult(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/std/StdClassAttribute/get_valid_default_value_result?${qs.stringify(payload)}`
      )
    )
    return Callback(err, res)
  }
  static async getValidRuleExpression(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/std/StdClassAttribute/valid_rule_expression?${qs.stringify(payload)}`
      )
    )
    return Callback(err, res)
  }
  static async getValue(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/StdClassData/code/attribute?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 获取个性元数据类型
  static async getPersonalityMetaDataList(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/StdPersonalityMetaData/list?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 保存个性元数据
  static async savePersonalityMetaData(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/StdPersonalityMetaData/save', payload)
    )
    return Callback(err, res)
  }
  // 获取个性元数据值
  static async getPersonalityMetaDataValue(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/std/StdPersonalityMetaData/getstdpersonalitymetadatavalue?${qs.stringify(payload)}`
      )
    )
    return Callback(err, res)
  }
}
